import Actions from '../Collection/actions'

const actions = Actions.get('CATEGORY_');

export default actions;
